import React, { useEffect, useState } from "react";
import ComponentMenu from "../../components/layout/ComponentMenu";
import { Container, NavDropdown } from "react-bootstrap";
import ComponentTitle from "../../components/layout/ComponentTitle";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { apiGetEngagement } from "../../api/ApiEngagement";
import ComponentOrgUnit from "../../components/public/orgunit/ComponentOrgUnit";
import ComponentLoader from "../../components/layout/ComponentLoader";
import { useTranslation } from "react-i18next";
import { MdBuild, MdOutlineCategory } from "react-icons/md";
import ModalChoixOrgunits from "../../components/admin/engagement/ModalChoixOrgunits";

const PageEngagement = () => {
  const { t } = useTranslation();
  const { ReduxInstance } = useSelector((state) => state.ReduxInstance);
  const { ReduxUserEmail } = useSelector((state) => state.ReduxUser);
  const [engagement, setEngagement] = useState("");
  const [loader, setLoader] = useState(false);
  let { id } = useParams();
  const [showOrgunits, setShowOrgunits] = useState(false);

  useEffect(() => {
    recupEngagements();
  }, [id]); // eslint-disable-line react-hooks/exhaustive-deps

  const recupEngagements = async () => {
    setLoader(true);
    const res = await apiGetEngagement(ReduxInstance._id, id, "include=orgUnits");
    if (res.data) {
      setEngagement(res.data);
    } else {
      console.log("error");
    }
    setLoader(false);
  };

  /* UTILE POUR LES ADMINISTRATEURS */
  const isAdminEasygouv = () => {
    // si je suis souscripteur
    if (ReduxUserEmail === ReduxInstance.souscripteur) return true;
    // si je suis dans le tableau des adminProcessAccess
    if (ReduxInstance.adminProcessAccess.indexOf(ReduxUserEmail) > -1) return true;

    return false;
  };

  const handleShowOrgunits = (id) => {
    setShowOrgunits(true);
  };

  const handleCloseOrgunits = () => {
    setShowOrgunits(false);
    recupEngagements();
  };

  // FIN UTILE ADMINSTRATEURS

  return (
    <>
      <ComponentMenu />
      <Container className="mb-5">
        <div className="d-flex align-items-end">
          <div className="flex-grow-1">
            <ComponentTitle title={engagement.nom} />
          </div>
          <div className="mb-4">
            {isAdminEasygouv() && (
              <div className="flex-grow-1 text-end">
                <MdOutlineCategory
                  size="1.5em"
                  role="button"
                  onClick={() => handleShowOrgunits(true)}
                  className=""
                />
                <ModalChoixOrgunits
                  show={showOrgunits}
                  idEngagement={engagement._id}
                  handleClose={handleCloseOrgunits}
                  ReduxInstanceId={ReduxInstance._id}
                />
              </div>
            )}
          </div>
        </div>
        {loader && (
          <div className="text-center">
            <ComponentLoader />
          </div>
        )}
        {!loader && (
          <div className="d-flex overflowContent" id="overflowOrgunits">
            {engagement.orgUnits && engagement.orgUnits.length > 0
              ? engagement.orgUnits
                  .sort((a, b) => (a.nom > b.nom ? 1 : b.nom > a.nom ? -1 : 0))
                  .map((orgunit, index) => <ComponentOrgUnit orgunitObject={orgunit} key={index} />)
              : t("public.componentEngagement.aucun")}
          </div>
        )}
      </Container>
    </>
  );
};

export default PageEngagement;
